export default __webpack_public_path__ + "static/media/car.2292d0a4.jpg";